<template>
  <div class="common-container">
    <van-image width="100%" fit="contain" :src="require('@/assets/imgs/book/authorize.png')" />
  </div>
</template>

<script>
export default {
  created() {
    document.title = "《委托授权书》";
  },
};
</script>

<style lang="scss" scoped>
.common-container {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/insurance/authorize_book.vue